export default __webpack_public_path__ + "static/1_resized-80f6a7c28aa8915788379039e6d79b0a.jpg";